import { DeviceAccessor } from "@mcleod/core";
import { ImageBundleBehavior } from "./ImageBundleBehavior";

/**
 * Behavior for ImageBundle components on tablet devices.
 * Uses ~52% larger sizing optimized for tablet screen sizes.
 */
export class ImageBundleTabletBehavior extends ImageBundleBehavior {

    /**
     * Tablet thumbnail size (121px vs 80px base).
     */
    override get thumbnailSize(): number {
        return 128;
    }

    /**
     * Tablet add page icon (36px vs 24px base).
     */
    override get addPageIconSize(): number {
        return 36;
    }

    /**
     * Tablet uses "medium" font size for add page label.
     */
    override get addPageLabelFontSize(): "xsmall" | "small" | "medium" | "large" {
        return "medium";
    }

    /**
     * Tablet delete button (35px vs 28px base).
     */
    override get thumbnailDeleteButtonSize(): number {
        return 35;
    }

    /**
     * Tablet delete icon (23px vs 18px base).
     */
    override get thumbnailDeleteIconSize(): number {
        return 23;
    }

    /**
     * Larger border radius for tablets (13px vs 8px base).
     */
    override get thumbnailBorderRadius(): number {
        return 13;
    }

    /**
     * Larger margin between thumbnails for tablets (13px vs 8px base).
     */
    override get thumbnailMargin(): number {
        return 13;
    }
}

if (DeviceAccessor.isApp && DeviceAccessor.isTablet) {
    ImageBundleTabletBehavior.register();
}
